<template>
  <div id="app">

    <admin-bar></admin-bar>

    <login-page v-if="!pageName"></login-page>

    <div id="app-content">
        <whereby-meeting></whereby-meeting>
      

      <div class="content-wrap">
        <div class="popups">
          <hint-page
            v-if="requestingHelpHint"
            @close="$store.commit('SET_HELP_HINT', false)"
          >
            <i>Waiting for help…</i>
          </hint-page>

          <hint-page
            v-show="showControllerHint"
            class="controllerHint"
            @close="$store.commit('SET_CONTROLLER_HINT', false)"
          >
            <p>
              <i>
                You are the "Controller".
                <br />
                <br />You can pass control at any time by clicking this icon.
              </i>
            </p>
            <img
              src="./assets/images/icon-participant.png"
              class="icon-preview"
            />
          </hint-page>

          <!-- The hint when user clicks one of three tactic images on the left -->
          <tactic-page
            v-show="showTactic"
            @close="$store.dispatch('showTactic', null)"
          ></tactic-page>

          <!-- The hint when the user clicks one of 9 icons in the menu, these depend on difficulty level -->
          <hint-page
            v-show="hintText"
            :hint="hintText"
            @close="$store.dispatch('showHint', null)"
          ></hint-page>

          <volume-control-page></volume-control-page>

          <controller-page v-show="showControllerPage"></controller-page>
        </div>

        <div class="pages">
          <component :is="activePage"></component>
        </div>
      </div>

      <div class="sidebar-wrap">
        <sidebar></sidebar>
      </div>
    </div>
  </div>
</template>

<script>
import pagesJson from "@/data/pages.json";

import { mapGetters, mapState } from "vuex";

import ControllerPage from "@/pages/ControllerPage.vue";
import LoginPage from "@/pages/LoginPage.vue";
import TimerPage from "@/pages/TimerPage.vue";
import ScenarioPage from "@/pages/ScenarioPage.vue";
import AftermathPage from "@/pages/AftermathPage.vue";
import PledgePage from "@/pages/PledgePage.vue";
import WelcomePage from "@/pages/WelcomePage.vue";
import SidesPage from "@/pages/SidesPage.vue";
import DifficultyPage from "@/pages/DifficultyPage.vue";
import NamesPage from "@/pages/NamesPage.vue";
import TaskPage from "@/pages/TaskPage.vue";
import StrategyPage from "@/pages/StrategyPage.vue";
import RolesPage from "@/pages/RolesPage.vue";
import HintPage from "@/pages/HintPage.vue";
import ConfirmPage from "@/pages/ConfirmPage.vue";
import QuestionnairePage from "@/pages/QuestionnairePage.vue";
import EndPage from "@/pages/EndPage.vue";
import HelpPage from "@/pages/HelpPage.vue";
import VolumeControlPage from "@/pages/VolumeControlPage.vue";

import Sidebar from "@/components/Sidebar.vue";
import AdminBar from "@/components/AdminBar.vue";
import WherebyMeeting from "@/components/WherebyMeeting.vue";
import TacticPage from "@/pages/TacticPage.vue";

export default {
  name: "app",

  components: {
    HelpPage,
    WherebyMeeting,
    LoginPage,
    TimerPage,
    ScenarioPage,
    WelcomePage,
    AftermathPage,
    PledgePage,
    SidesPage,
    DifficultyPage,
    NamesPage,
    TaskPage,
    StrategyPage,
    RolesPage,
    HintPage,
    ConfirmPage,
    QuestionnairePage,
    EndPage,
    Sidebar,
    AdminBar,
    VolumeControlPage,
    TacticPage,
    ControllerPage
  },

  data: function () {
    WherebyMeeting;
    return {};
  },

  computed: {
    ...mapGetters([
      "hints",
      "task",
      "currentPage",
      "pageList",
      "isController",
      "showTactic",
    ]),
    ...mapState([
      "pageName",
      "countdown",
      "connectionStatus",
      "selectedArchetype",
      "selectedRole",
      "side",
      "difficulty",
      "pageName",
      "hintText",
      "requestingHelp",
      "requestingHelpHint",
      "user",
      "showControllerHint",
      "showControllerPage",
    ]),

    activePage() {
      if (this.pageName) {
        return this.pageName + "-page";
      } else {
        return null;
      }
    },
  },

  watch: {
    countdown(newTime, oldTime) {
      if (!newTime && oldTime) {
        // stop playing the countdown audio just in case
        this.$store.dispatch("stopHowler", "countdown");
      } else if (!oldTime && newTime) {
        // Timer started
      } else {
        // should we start a countdown sound?
        if (
          !this.currentPage.isVideo &&
          newTime <= 40000 &&
          !this.$store.state.howler.countdown.playing()
        ) {
          this.$store.dispatch("playHowler", "countdown");
        }

        // should we move to the next page
        if (newTime <= 0 && this.user.isAdmin) {
          // clear the timer
          this.$store.dispatch("stopCountdown");

          // got to the next page
          this.$store.dispatch("gotoNextPage");
        }
      }
    },

    pageName(newPage, oldPage) {
      // disable, pause, stop anything on the page
      this.transitionOut(oldPage);

      if (newPage == "end") {
        // Stop the countdown
        this.$store.dispatch("stopCountdown");
        console.log(">>> SAVE ALL DATA THE EXPERIENCE IS OVER <<<");
      } else {
        // Make sure a side is set if people run out of time
        if (newPage == "task" && !this.side) {
          this.$store.commit("SET_SIDE", "advocate");
        }

        // check if we need to preload the next sections audio
        let nextPageIndex = pagesJson.findIndex((p) => p.name === newPage) + 1;
        if (nextPageIndex <= pagesJson.length) {
          this.$store.dispatch("preloadHowler", pagesJson[nextPageIndex].name);
        }

        // Only manage timer if you're an admin
        if (this.user.isAdmin) {
          // start a new countdown
          this.$store.dispatch("stopCountdown");

          // Check and setup a new countdown
          if (this.currentPage.duration) {
            this.$store.dispatch(
              "startCountdownInSecs",
              this.currentPage.duration
            );
          }
        }
      }

      // Handle sounds
      this.$store.dispatch("stopAllHowler", oldPage);
      this.$store.dispatch("playHowler", newPage);
    },

    isController(newValue) {
      if (newValue) {
        this.$store.commit("SET_CONTROLLER_HINT", true);
        this.$store.dispatch("playHowler", "denied");

        // give the body tag a border
        document.body.style.border = '20px solid black';
      } else {
        document.body.style.border = 'none';
      }
    },

    requestingHelp(newValue, oldValue) {
      if (newValue) {
        console.log("PLAY HELP SOUND");

        // play a help sound
        this.$store.dispatch("playHowler", "denied");
      }
    },
  },

  methods: {
    transitionOut(oldPage) {
      switch (oldPage) {
        case "sides":
          if (this.side === "") {
            this.$store.commit("SET_SIDE", "advocate");
          }
          break;

        case "difficulty":
          if (this.difficulty === "") {
            // set difficult to default = easy
            this.$store.commit("SET_DIFFICULTY", "easy");
          }

          break;
      }
    },
  },

  mounted() {
    console.log("TheAdv " + this.$store.state.appVersion);

    // Check for a valid session code in the URL
    var pathArray = window.location.pathname.split("/");
    if (!pathArray[1]) {
      this.$store.commit("SET_CONNECTION_STATUS", {
        type: "error",
        message:
          "The session could not be found please check your link and try again",
      });
    } else {
      // connect to Airtable and retrieve results
      this.$store.dispatch("fetchSession", pathArray[1]).then(() => {
        this.$store.dispatch("fetchVideoURLs");
      });
    }
  },
  created() {
    window.addEventListener("beforeunload", (event) => {
      event.returnValue = `Are you sure you want to leave?`;
    });
  },
};
</script>

<style lang="scss">
body {
  height: 100vh;
  background-color: #f1ece6;
}

#app {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#app-content {
  width: 100%;
  height: 768px;
  display: flex;
}



.content-wrap {
  width: 768px;
}

.sidebar-wrap {
  flex: 1;
  display: flex;
}

.popups {
  z-index: 200;
  position: absolute;
}
.pages {
  z-index: 100;
  position: absolute;
}

.controllerHint {
  z-index: 300;
}

.icon-preview {
  display: block;
  margin-top: 30px;
  width: 40px;
  height: 40px;
  object-fit: cover;
  object-position: 0 0;
}
</style>
